// SettingBox is just styling component.
import { SettingBox } from '../styles';
import Plans from '@/components/Plans/Plans';
import { FC } from 'react';
import { Subscription } from '@/services/noteGoApi/noteGoApiSchemas';
import { Stack, styled } from '@mui/material';
import { RouteMap } from '@/routes/Routes';

/**
 * Props for the PlansSection component.
 *
 * @property handleUpgrade - Callback function invoked when the user chooses to upgrade their plan.
 *   - @param frequencyId - The ID representing the billing frequency.
 *   - @param subscriptionId - (Optional) The current subscription ID, if available.
 *   - @param stripeCustomerId - (Optional) The Stripe customer ID, if available.
 * @property onDowngradeToFree - (Optional) Callback function invoked when user selects the FREE lifetime plan.
 * @property currentUserPlan - (Optional) The user's current subscription, or null if not subscribed.
 */
interface PlansSectionProps {
  handleUpgrade: (frequencyId: string, subscriptionId?: string | null, stripeCustomerId?: string | null) => void;
  onDowngradeToFree?: (productId?: string) => void;
  currentUserPlan?: Subscription | null;
}

// Styling component
const PlansWrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: 'white',
  padding: '1.5rem',
  borderRadius: '1.5rem',
  border: `1px solid ${theme.palette.neutral.otherBorder}`,
  flex: 1,
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: '1rem',
    borderRadius: '1rem',
  },
}));

const PlansSection: FC<PlansSectionProps> = ({ handleUpgrade, onDowngradeToFree, currentUserPlan }) => (
  <SettingBox id={RouteMap.PLAN_ANCHOR}>
    <PlansWrapper>
      <Plans
        handleUpgrade={handleUpgrade}
        onDowngradeToFree={onDowngradeToFree}
        currentUserPlan={currentUserPlan}
        isLoading={false}
      />
    </PlansWrapper>
  </SettingBox>
);

export default PlansSection;
